import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
// import CheckInstallation from "./CheckInstallation";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import LightCircular from "./components/Progressbar/LightCircular";
const Frame = lazy(() => import("./components/Frame/Frame"));

ReactDOM.render(
  <Suspense
    fallback={
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width:'100%'
        }}
      >
        <LightCircular />
      </div>
    }
  >
    <Frame />
  </Suspense>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();
